/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ColorConversion from 'utilities/ColorConversion';

const WHEEL_PIXEL_SIZE = 225;
const WHEEL_ORIGIN_OFFSET = WHEEL_PIXEL_SIZE/2;

export default class ColorWheel extends Component{

	static propTypes = {
		onColorChange: PropTypes.func,
		color: PropTypes.string
	}

	static defaultProps = {
		color: '#FFFFFF'
	}

	constructor(props){
		super(props);

		this.colorWheel = null;
		this.colorPicker = null;
		this.state = {
			pickerColor: null
		};
	}

	componentDidMount() {
		this._drawCanvas();
		this.colorWheel.onclick = this.colorPicker.onclick = this._clickOnPalette.bind( this );
	}

	_drawCanvas = () =>{
		const canvasContext = this.colorWheel.getContext('2d');
		// Center coordinates of the color wheel
		const xCoordinate = WHEEL_ORIGIN_OFFSET;
		const yCoordinate = WHEEL_ORIGIN_OFFSET;
		//Radius of the color wheel
		const iRadius = WHEEL_ORIGIN_OFFSET;
		const bCounterClockwise = false;

		//For loop used to draw the color wheel pixel by pixel on the canvas
		for ( let angle = 0; angle <= 360; angle++) {
			const v_iStartAngle = (angle - 2) * Math.PI/180;
			const v_iEndAngle = angle  * Math.PI/180;
			canvasContext.beginPath();
			canvasContext.moveTo(xCoordinate, yCoordinate);
			canvasContext.arc(xCoordinate, yCoordinate, iRadius, v_iStartAngle, v_iEndAngle, bCounterClockwise);
			canvasContext.closePath();
			const v_iGradient = canvasContext.createRadialGradient(xCoordinate, yCoordinate, 0, xCoordinate, yCoordinate, iRadius);
			v_iGradient.addColorStop(0, 'hsl(' + angle + ', 10%, 100%)');
			v_iGradient.addColorStop(1, 'hsl(' + angle + ', 100%, 50%)');
			canvasContext.fillStyle = v_iGradient;
			canvasContext.fill();
		}
	}

	_clickOnPalette = (event) =>{
		let eventX = null;
		let eventY = null;

		if(event.type == 'touchmove'){
			eventX = event.targetTouches[0].clientX;
			eventY = event.targetTouches[0].clientY;
		}else{
			eventX = event.clientX;
			eventY = event.clientY;
		}

		const elementRelativePosition = this._getRelativeOffset();
		let x = eventX - elementRelativePosition.left;
		let y = eventY - elementRelativePosition.top;

		let pickerOffsetWidth = this.colorPicker.offsetWidth / 2 + 1;
		let pickerOffsetHeight = this.colorPicker.offsetHeight / 2;

		// if clicking outside the radius of the circle, move it to the outside edge of the circle
		const circleX = x - WHEEL_ORIGIN_OFFSET;
		const circleY = WHEEL_ORIGIN_OFFSET - y;
		const radius = Math.sqrt( Math.pow( circleX, 2 ) + Math.pow( circleY, 2 ) );
		if ( radius > WHEEL_ORIGIN_OFFSET ) {
			const fixedCircleX = (WHEEL_ORIGIN_OFFSET * Math.cos( Math.acos(circleX/radius) ));
			const fixedCircleY = (WHEEL_ORIGIN_OFFSET * Math.sin( Math.asin(circleY/radius) ));
			x = fixedCircleX + WHEEL_ORIGIN_OFFSET;
			y = WHEEL_ORIGIN_OFFSET - fixedCircleY;
		}

		const rgbHex = ColorConversion.convertRgbValToRgbHex( this._getCanvasColor( x, y ));
		if ( rgbHex === '#000000') {
			// this is an error state in IE, where a color could not be retrieved from the canvas (our canvas has no black)
			// return and let the user try to click again
			return;
		}
		this.setState({ pickerColor: rgbHex });
		this.colorPicker.style.left = (x - pickerOffsetWidth) +'px';
		this.colorPicker.style.top = (y - (this.colorWheel.height + pickerOffsetHeight)) +'px';
		this.props.onColorChange(rgbHex, false);
	}

	_getRelativeOffset(){
		const clientRect = this.colorWheel.getBoundingClientRect();
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		const position = { top: (clientRect.top + scrollTop), left: (clientRect.left + scrollLeft) };

		return position;
	}

	_getCanvasColor(left, top){
		const dataArray = this.colorWheel.getContext('2d').getImageData(left, top, 1, 1).data;
		return {
			red: dataArray[0],
			green: dataArray[1],
			blue: dataArray[2]
		};
	}

	render(){
		return(
			<div style={{ height: WHEEL_PIXEL_SIZE + 'px', width: WHEEL_PIXEL_SIZE + 'px' }}>
				<canvas
					width={WHEEL_PIXEL_SIZE}
					height={WHEEL_PIXEL_SIZE}
					id='colorWheel'
					ref={(element) => {this.colorWheel = element;}}
				/>
				<div
					id='colorPicker'
					style={{ backgroundColor: this.state.pickerColor, visibility: this.state.pickerColor && this.state.pickerColor === this.props.color ? '' : 'hidden' }}
					className={'clsWheelSelector clsWheelSelectorEmpty clsPickerWrapper'}
					ref={(element) => {this.colorPicker = element;}}>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/ColorWheel.js